<div class="contentHeight">
    <div class="container">
        <div class="backgroundWhiteRound managerContainer">
            <div class="filtre row">
                <form [formGroup]="searchCustomerForm" class="searchCustomerForm">
                    <mat-form-field class="country">
                        <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                        <mat-select formControlName="country" required (selectionChange)="getRegions(false,'new', false); displayAnnuaire(); refreshCTCList($event.value)">
                            <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="postalCode">
                        <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                        <input matInput formControlName="postalCode" required autocomplete="off">
                    </mat-form-field>

                    <span *ngIf="annuaireIxell">
                        <mat-checkbox class="annuaireIxell" [(ngModel)]="checkedAnnuaire" [ngModelOptions]="{standalone: true}">
                            <span>{{'scaleform.annuaireIxell'|translate}}</span>
                        </mat-checkbox>
                    </span>

                    <div class="client-filter-container">
                        <label class="client-filter-container-label">{{'manageaccount.labelVoir'|translate}}{{'stats.common.colon'|translate}}</label>
                        <div class="client-filter-container-div">
                            <mat-radio-group class="client-filter" formControlName="clientFilter">
                                <mat-radio-button [value]=0 labelPosition="after" [checked]="true">{{'planning.all'|translate}}</mat-radio-button>
                                <mat-radio-button [value]=1 labelPosition="after">{{'manageaccount.mesClientsSeulement'|translate}}</mat-radio-button>
                                <mat-radio-button [value]=2 labelPosition="after" #clientsOfRadio class="clientsOfRadioBtn">
                                    <span>{{'manageaccount.clientsDe'|translate}}{{'stats.common.colon'|translate}}</span>
                                    <div class="client-filter-container-listCtc">
                                        <mat-form-field>
                                            <mat-select placeholder="CTC" formControlName="clientOfId" [required]="clientsOfRadio.checked" [disabled]="!clientsOfRadio.checked">
                                                <mat-option *ngFor="let availableCTC of availableCTCs" [value]=availableCTC.idCtc> {{(availableCTC.firstname == null) ? '' : availableCTC.firstname}} {{availableCTC.name}} </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="buttons-container">
                        <button class="btn btn-secondary heightAuto" (click)="searchCustomer()" [translate]="'search.searchBtn'"></button>
                        <button class="btn btn-secondary histo heightAuto" (click)="getCustomerByCtcId()" [translate]="'manageaccount.histo'"></button>
                    </div>
                </form>
            </div>

            <span class="noresult" *ngIf="noResults">{{'manageaccount.noResult'|translate}}<br /></span>

            <div *ngIf="customersLst.length > 0" class="tableContainer">
                <div>
                    <table mat-table class="table lstclients bg-white table-hover customers" matSort [dataSource]="customersSource" (matSortChange)="sort($event,'1')">

                        <ng-container matColumnDef="autoConnexion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let res">
                                <div *ngIf="res.mail" (click)="autoConnexion(res.idcolorUser)" class="pointer autoConnexion">
                                    <span><i aria-hidden="true" class="fal fa-sync fa-2x"></i></span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="companySocialReason">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="socialReason">{{res.socialReason}}</td>
                        </ng-container>

                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <div class="address">
                                    <span>{{res.address}}</span> <span>{{res.postalCode}} {{res.city}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="firstName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.prenom'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="firstName">{{res.firstname|titlecase}}</td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="name">{{res.name|uppercase}}</td>
                        </ng-container>

                        <ng-container matColumnDef="mail">
                            <th mat-header-cell *matHeaderCellDef>{{'scaleform.mail'|translate}}</th>
                            <td mat-cell *matCellDef="let res" class="mail">{{res.mail}}</td>
                        </ng-container>

                        <ng-container matColumnDef="sended">
                            <th mat-header-cell *matHeaderCellDef>{{'manageaccount.mailsended'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                <span *ngIf="res.mailSended"> {{res.dateMailSent}} </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="histo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.connection'|translate}}</th>
                            <td mat-cell *matCellDef="let res">
                                {{res.nbConnection}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="d-inline-flex flex-row justify-content-center align-items-center">
                                    <span class="spanAction">{{'manageaccount.action'|translate}}</span>
                                    <div class="spanAction"><i aria-hidden="true" class="fal fa-2x fa-info-circle primaryInfo" title="{{'manageaccount.infoBoutonAction'|translate}}"></i></div>
                                </div>
                            </th>

                            <td mat-cell *matCellDef="let res" class="">
                                <table class="actionTable" style="width: 100%;">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="actionmail" *ngIf="res.mailSended" (click)="openDeleteMailModal(res)" matTooltip="{{'manageaccount.deleteDateMail'|translate}}">
                                                    <i aria-hidden="true" class="fal fa-recycle fa-2x primaryGrey actionIcon"></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="actionhidde" *ngIf="res.ctcCreated" (click)="openDeleteAccountModal(res)" matTooltip="{{'manageaccount.hidde'|translate}}">
                                                    <i aria-hidden="true" class="fal fa-trash-alt fa-2x primaryGrey actionIcon"></i>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="actionedit" (click)="editCustomer(res)" matTooltip="{{'manageaccount.edit'|translate}}">
                                                    <i aria-hidden="true" class="fal fa-edit fa-2x primaryGrey actionIcon primaryGrey-{{res.haveCtcAndDR}}"></i>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="seeMore">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let res" class="">
                                <div class="seeMoreBtn" (click)="openSeeMoreModal(res)" matTooltip="{{'accountChoice.infosupp'|translate}}">
                                    <i aria-hidden="true" class="fal fa-chevron-right fa-2x primaryInfo actionIcon"></i>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
            </div>
            <button class="btn btn-secondary mb-2 mt-2 heightAuto" (click)="showAddUserModal()">{{'manageaccount.addUser'|translate}}</button>
        </div>
    </div>
</div>

<!-- Modal Nouvel utilisateur -->
<div id="new" class="modal">
    <div class="modal-content" id="modalNewUserContent" *ngIf="!validationModal && !confirmationDeleteMail && !confirmationDeleteAccount">

        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('new');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> {{'manageaccount.addUser'|translate}} </h1>
            <hr />
        </div>
        <div class="contain">
            <div class="alertmsg col-12">
                <div class="msg">
                    <span *ngIf="emailExists" class="red">{{'manageaccount.emailExists'|translate}}</span>
                    <span *ngIf="(currentCustomer && currentCustomer.mailSended) || (otherCustomer && otherCustomer.mailSended)" class="red">{{'manageaccount.mailSended'|translate}}</span>
                </div>
                <div *ngIf="emailExists">
                    <button class="btn btn-secondary wide heightAuto" (click)="showOtherCustomer('new')" *ngIf="!showOther">{{'manageaccount.showInformation'|translate}}</button>
                    <button class="btn btn-secondary wide heightAuto" (click)="hideOtherCustomer('new')" *ngIf="showOther">{{'manageaccount.hideInformation'|translate}}</button>
                </div>
            </div>
            <div class="emailDiv form-group row justify-content-center mt-3">
                <div [formGroup]="customerEmailForm" class="col-12" *ngIf="showMailForm">
                    <mat-form-field class="col-12">
                        <mat-label>{{'renting.mailclient'|translate}}</mat-label>
                        <input matInput type="email" (change)="checkMail(customerEmailForm.value.email, 'new')" formControlName="email" required />
                    </mat-form-field>



                    <!--<mat-form-field class="col-12">
                      <mat-label>{'manageaccount.emergencyMail'|translate}}</mat-label>
                      <input matInput type="email" formControlName="email" required />
                    </mat-form-field>-->



                    <div *ngIf="errorMsgMail" class="errorMsg text-center">{{'manageaccount.errorMsgMail'|translate}}</div>
                    <div class="row justify-content-center">
                        <button class="btn btn-secondary" *ngIf="!emailExists" (click)="validMailForm()" [translate]="'scaleform.suivant'"> </button>
                    </div>
                </div>
                <!-- Formulaire Société-->
                <div class="companyDiv form-group justify-content-center" *ngIf="showCompanyForm">
                    <div [formGroup]="companyForm" class="col-12">
                        <span class="col-12 bold">{{'register.companyInfo'|translate}}</span><br />
                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                            <input matInput formControlName="socialReason" required />
                        </mat-form-field>
                        <mat-form-field class="col-12">
                            <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                            <input matInput formControlName="address" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                            <input matInput formControlName="postalCode" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                            <input matInput formControlName="city" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                            <mat-select formControlName="country" required (selectionChange)="getRegions(false,'new', true); changeCompanyFormCountryFacturation();">
                                <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                            <input matInput formControlName="siren" required />
                        </mat-form-field>

                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                            <input matInput formControlName="tva" required />
                            <mat-error>{{'scaleform.tvaerror'|translate}}</mat-error>
                        </mat-form-field>

                    </div>
                    <div class="row justify-content-center">
                        <button class="btn btn-secondary mr-2" (click)="returnToMailForm()" [translate]="'scaleform.precedent'"> </button>
                        <button class="btn btn-secondary" (click)="searchSimilarCompany()" [translate]="'scaleform.suivant'"> </button>
                    </div>
                </div>

                <!-- Liste des sociétés-->
                <div *ngIf="showListCompany" class="listCompanyDiv col-12">
                    <div class="col-12 mb-3">
                        <span>{{'manageaccount.similarCompany'|translate}} :</span>
                    </div>
                    <div class="col-12 " [formGroup]="similarCompanyForm" style="margin: 0 auto;">
                        <mat-radio-group class="row ml-2 radio-group-column" formControlName="similarCompany" required>
                            <mat-radio-button (click)="chooseCompany('new')" value="new">{{'manageaccount.newCompany'|translate}}</mat-radio-button>
                            <mat-radio-button *ngFor="let company of similarCompany; let i=index" value="{{i}}" (click)="chooseCompany(company)">
                                <span class="breakWord">
                                    {{company.socialReason | uppercase}} - {{company.address | titlecase}} {{company.postalCode}} {{company.city | uppercase}}
                                    <span *ngIf="company.siren != null && company.siren != undefined && company.siren != ''">
                                        <br />
                                        {{'scaleform.siret'|translate}} : {{company.siren }}
                                    </span>
                                    <span *ngIf="company.tva != null && company.tva != undefined && company.tva != ''">
                                        <br />
                                        {{'shoppingcart.tva'|translate}} : {{company.tva }}
                                    </span>
                                </span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="errorMsgCompany" class="errorMsg text-center mt-3">{{'manageaccount.errorMsgCompany'|translate}}</div>
                    <div class="row justify-content-center">
                        <button class="btn btn-secondary mr-2" [translate]="'scaleform.precedent'" (click)="displayCompanyForm()"></button>
                        <button class="btn btn-secondary" [translate]="'scaleform.suivant'" (click)="selectCompany()"></button>
                    </div>
                </div>


                <!-- Vérification données société -->
                <div *ngIf="showVerifCompany" class="verifCompanyDiv col-12">
                    <div class="col-12 mb-3" [formGroup]="dataCompanyForm" style="display:flex; flex-direction:row;">
                        <mat-radio-group class="col-12 row" formControlName="dataCompany">
                            <div class="col-6" style="margin: 0 auto;">
                                <div style="margin: 0 auto;">
                                    <mat-radio-button (click)="selectInfosCompany(companyEntered)" value="0">{{'manageaccount.dataCompanyEntered'|translate}}</mat-radio-button>
                                </div>
                                <div> {{'scaleform.raisonsociale'|translate}} : <span style="font-weight: bold">{{companyEntered.socialReason}}</span> </div>
                                <div> {{'scaleform.adresse'|translate}} : <span style="font-weight: bold">{{companyEntered.address}}</span> </div>
                                <div> {{'scaleform.codepostal'|translate}} : <span style="font-weight: bold">{{companyEntered.postalCode}}</span> </div>
                                <div> {{'scaleform.ville'|translate}} : <span style="font-weight: bold">{{companyEntered.city}}</span> </div>
                                <div> {{'scaleform.pays'|translate}} : <span style="font-weight: bold">{{companyEntered.country}}</span> </div>
                                <div> {{'scaleform.siret'|translate}} : <span style="font-weight: bold">{{companyEntered.siren}}</span> </div>
                                <div> {{'scaleform.tva'|translate}} : <span style="font-weight: bold">{{companyEntered.tva}}</span> </div>
                            </div>
                            <div class="col-6 " style="margin: 0 auto;">
                                <div style="margin: 0 auto;">
                                    <mat-radio-button (click)="selectInfosCompany(companySelected)" value="1">{{'manageaccount.dataCompanySelected'|translate}}</mat-radio-button>
                                </div>
                                <div> {{'scaleform.raisonsociale'|translate}} : <span style="font-weight: bold">{{companySelected.socialReason}}</span> </div>
                                <div> {{'scaleform.adresse'|translate}} : <span style="font-weight: bold">{{companySelected.address}}</span> </div>
                                <div> {{'scaleform.codepostal'|translate}} : <span style="font-weight: bold">{{companySelected.postalCode}}</span> </div>
                                <div> {{'scaleform.ville'|translate}} : <span style="font-weight: bold">{{companySelected.city}}</span> </div>
                                <div> {{'scaleform.pays'|translate}} : <span style="font-weight: bold">{{companySelected.country}}</span> </div>
                                <div> {{'scaleform.siret'|translate}} : <span style="font-weight: bold">{{companySelected.siren}}</span> </div>
                                <div> {{'scaleform.tva'|translate}} : <span style="font-weight: bold">{{companySelected.tva}}</span> </div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="errorMsgVerifCompany" class="errorMsg text-center mt-3">{{'manageaccount.errorMsgVerifCompany'|translate}}</div>

                    <div class="row justify-content-center">
                        <button class="btn btn-secondary mr-2" [translate]="'scaleform.precedent'" (click)="displayListCompany()"></button>
                        <button class="btn btn-secondary" [translate]="'scaleform.suivant'" (click)="displayListCustomers()"></button>
                    </div>
                </div>


                <!-- Liste des utilisateurs de la société sélectionnée -->
                <div *ngIf="showCustomerCompany" class="listCustomerDiv col-12  ">
                    <div class="col-12 mb-3">
                        <div class="col-12">{{'manageaccount.companySelected'|translate}} : {{dataCompanySelected.socialReason}} - {{dataCompanySelected.address}} {{dataCompanySelected.postalCode}} {{dataCompanySelected.city}}</div>
                    </div>
                    <div class="col-12" [formGroup]="customerCompanyForm" style="margin: 0 auto;">
                        <mat-radio-group formControlName="customerCompany" class="col-12 radio-group-column">
                            <mat-radio-button (click)="select('new')" value="new">{{'manageaccount.newUser'|translate}}</mat-radio-button>
                            <mat-radio-button *ngFor="let customer of similarCustomers" value="{{customer.idcolorUser}}" (click)="select(customer)">
                                <span class="breakWord">
                                    {{customer.name | uppercase}} {{customer.firstname | titlecase}} - {{customer.mail}} <!--({{customer.idcolorUser}})-->
                                </span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="errorMsgCustomer" class="errorMsg text-center mt-3">{{'manageaccount.errorMsgUser'|translate}}</div>

                    <div class="row justify-content-center">
                        <button class="btn btn-secondary mr-2" [translate]="'scaleform.precedent'" (click)="displayVerifCompany()"></button>
                        <button class="btn btn-secondary" [translate]="'scaleform.suivant'" (click)="displayCustomerForm()"></button>
                    </div>
                </div>


                <!-- Formulaire Utilisateur -->
                <div *ngIf="showCustomerForm" class="col-12 customerDiv">
                    <div *ngIf="!isNewCompany && companySelected != null" class="col-12 mt-3 mb-3">
                        <div class="">{{'manageaccount.companySelected'|translate}} : {{dataCompanySelected.socialReason}} - {{dataCompanySelected.address}} {{dataCompanySelected.postalCode}} {{dataCompanySelected.city}} </div>
                    </div>
                    <div *ngIf="customerSelected != null && customerSelected != 'new'" class="col-12 mb-3">
                        <div class="">{{'manageaccount.userSelected'|translate}} : {{customerSelected.mail}}</div>
                    </div>
                    <div class="" [formGroup]="customerForm">
                        <span class="col-12 bold">{{'register.userInfo'|translate}}</span><br />


                        <div class="col-12 col-sm-6">
                            <mat-checkbox formControlName="isAdminIVC">Admin IVC</mat-checkbox>
                        </div>

                        <mat-form-field class="col-12 col-sm-6 mt-2">
                            <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                            <input matInput formControlName="name" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                            <input matInput formControlName="firstName" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                            <input matInput type="tel" formControlName="mobile" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                            <input matInput type="tel" formControlName="phone" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                            <mat-select formControlName="language" required>
                                <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'contretypage.ctc'|translate}}</mat-label>
                            <mat-select formControlName="idCtc" (selectionChange)="ctcSelected('new')">
                                <mat-option *ngFor="let ctcFiltered of ctcsFiltered" value="{{ctcFiltered.idCtc}}">{{ctcFiltered.firstname}} {{ctcFiltered.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <br />
                        <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && companyForm.controls['country'].value && companyForm.controls['country'].value.toLowerCase() == 'france'">
                            <mat-label>{{'manageaccount.DR'|translate}}</mat-label>
                            <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('new', 'dr')">
                                <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && companyForm.controls['country'].value && companyForm.controls['country'].value.toLowerCase() == 'united kingdom'">
                            <mat-label>{{'manageaccount.country'|translate}}</mat-label>
                            <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('new', 'dr')">
                                <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                            </mat-select>

                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && companyForm.controls['country'].value && companyForm.controls['country'].value.toLowerCase() == 'spain'">
                            <mat-label>{{'manageaccount.region'|translate}}</mat-label>
                            <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('new', 'dr')">
                                <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'register.customerNumber'|translate}}</mat-label>
                            <input matInput formControlName="customerNumber" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'register.customerCode'|translate}}</mat-label>
                            <input matInput formControlName="customerCode" required />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'manageaccount.compteTresor'|translate}}</mat-label>
                            <input matInput formControlName="compteTresor" required />
                        </mat-form-field>
                        <br />
                        <div class="mt-2" *ngIf="newCustomer">
                            <mat-radio-group formControlName="haveScale" class="col-12">
                                <span class="pr-1">{{'manageaccount.haveScale'|translate}}</span>
                                <mat-radio-button class="ml-2" (change)="newCustomerHaveScale(true)" (click)="newCustomerHaveScale(true)" [value]="1">
                                    <span> {{'assistance.oui'|translate}} </span>
                                </mat-radio-button>
                                <mat-radio-button class="ml-2" (change)="newCustomerHaveScale(false)" (click)="newCustomerHaveScale(false)" [value]="2">
                                    <span> {{'assistance.non'|translate}}</span>
                                </mat-radio-button>
                            </mat-radio-group>
                            <mat-form-field *ngIf="haveScale" class="paintBrand col-12">
                                <mat-label>{{'register.brand'|translate}}</mat-label>
                                <mat-select formControlName="paintBrand">
                                    <mat-option *ngFor="let paintBrand of listOfBrands" [value]="paintBrand">{{paintBrand}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="action">
                        <button class="btn btn-secondary mr-2 actionButton" [translate]="'scaleform.precedent'" (click)="getPreviousCustomerForm()"></button>
                        <button *ngIf="!newCustomer" class="btn btn-secondary mr-2 col-5 col-lg-4 col-md-4 col-sm-5 actionButton" (click)="saveCustomer('new')">{{'manageaccount.save'|translate}}</button>
                        <button class="btn btn-secondary col-5 col-lg-4 col-md-4 col-sm-5 actionButton" (click)="saveAndSendCustomer('new')" [disabled]="emailExists">{{'manageaccount.sendID'|translate}}</button>
                    </div>
                    <div class="col-12 text-center mt-3"> <span *ngIf="msgConfirmation">{{'manageaccount.msgRegister'|translate}}</span></div>

                </div>

                <!-- Utilisateur existant (adresse mail) -->
                <div *ngIf="showOther" class="col-12">
                    <form [formGroup]="otherCustomerForm" class="customerForm otherCustomerForm">
                        <div class="companyDiv">
                            <span class="col-12 bold">{{'register.companyInfo'|translate}}{{'manageaccount.existingf'|translate}}</span><br />
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                <input matInput formControlName="socialReason" required [readonly]="otherCustomer.socialReason != null && otherCustomer.socialReason != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                <input matInput formControlName="address" required [readonly]="otherCustomer.address != null && otherCustomer.address != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                <input matInput formControlName="postalCode" required [readonly]="otherCustomer.postalCode != null && otherCustomer.postalCode != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                <input matInput formControlName="city" required [readonly]="otherCustomer.city != null && otherCustomer.city != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                <mat-select formControlName="country" required>
                                    <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                                </mat-select>
                            </mat-form-field>


                            <mat-form-field class="col-12 mt-2">
                                <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                                <input matInput formControlName="siren" required [readonly]="true" />
                            </mat-form-field>

                            <mat-form-field class="col-12 mt-2">
                                <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                                <input matInput formControlName="tva" required [readonly]="true" />
                            </mat-form-field>

                        </div>

                        <div class="customerDiv">
                            <span class="col-12 bold">{{'register.userInfo'|translate}}{{'manageaccount.existingm'|translate}}</span><br />


                            <div class="col-12 col-sm-6">
                                <mat-checkbox formControlName="isAdminIVC" [readonly]="true">Admin IVC</mat-checkbox>
                            </div>

                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                                <input matInput formControlName="name" required [readonly]="otherCustomer.name != null && otherCustomer.name != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                                <input matInput formControlName="firstName" required [readonly]="otherCustomer.firstname != null && otherCustomer.firstname != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                                <input matInput type="tel" formControlName="mobile" required [readonly]="otherCustomer.mobilePhone != null && otherCustomer.mobilePhone != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                                <input matInput type="tel" formControlName="phone" [readonly]="otherCustomer.phone != null && otherCustomer.phone != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                                <mat-select formControlName="language" required>
                                    <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <br />
                            <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenaultOther">
                                <mat-label>{{'register.businessCode'|translate}}</mat-label>
                                <mat-select formControlName="businessCode">
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'register.customerNumber'|translate}}</mat-label>
                                <input matInput formControlName="customerNumber" required [readonly]="otherCustomer.mrpAccount != null && otherCustomer.mrpAccount != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'register.customerCode'|translate}}</mat-label>
                                <input matInput formControlName="customerCode" required [readonly]="otherCustomer.customerCode != null && otherCustomer.customerCode != ''" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'manageaccount.compteTresor'|translate}}</mat-label>
                                <input matInput formControlName="compteTresor" required [readonly]="otherCustomer.compteTresor != null && otherCustomer.compteTresor != ''" />
                            </mat-form-field>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Envoi des mails -->
<div id="envoiMailModal" class="modal">
    <div class="modal-content" id="envoiMailContent">
        <span *ngIf="haveMailPrincipal"><strong>{{'manageaccount.checkboxEnvoiMail'|translate}}</strong></span>
        <mat-checkbox [disabled]="haveChangeMailPrincipal" [checked]="checkBoxMailPrincipal" (change)="envoiMailCheckMail('principal')">{{mailCustomer}}</mat-checkbox>
        <mat-checkbox *ngIf="haveMailSecondaire" [disabled]="" [checked]="checkBoxMailSecondaire" (change)="envoiMailCheckMail('secondaire')">{{emergencyMailCustomer}}</mat-checkbox>
        <button class="btn btn-secondary mx-auto" (click)="envoiMailIdentifiant()">{{'manageaccount.sendID'|translate}}</button>
    </div>
</div>

<!-- Validation -->
<div id="validationModal" class="modal">
    <div class="modal-content" id="validationContent">
        <div class="contain validation">
            <span *ngIf="haveMailPrincipal"><strong>{{'manageaccount.validSending'|translate}}</strong></span>
            <span *ngIf="haveMailPrincipal" class="mt-3">{{mailCustomer}}</span>
            <br />
            <span *ngIf="haveMailSecondaire"><strong>{{'manageaccount.validSending'|translate}}</strong></span>
            <span *ngIf="haveMailSecondaire" class="mt-3">{{emergencyMailCustomer}}</span>
            <button class="btn btn-secondary mx-auto" (click)="closeModal('validationModal')">{{'activlist.fermer'|translate}} </button>
        </div>
    </div>
</div>

<!-- Confirmation DeleteMail -->
<div id="confirmationDeleteMailModal" class="modal">
    <div class="modal-content" id="confirmationDeleteMailContent" *ngIf="confirmationDeleteMail">
        <div class="col-12">
            <!--<span class="text-right pointer close" (click)="closeModal('confirmationDeleteMailModal');">
              <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>-->
            <h3 class="modal-title text-center"> {{'manageaccount.supMail'|translate}}</h3>
            <hr />
        </div>
        <div class="row mt-3 mb-3">
            <span class="col-12 text-center mb-4">{{'manageaccount.confirmDeleteMail'|translate}}</span>
            <span class="col-12 text-center modal-text">{{deleteMailCustomer.socialReason | uppercase}} - {{deleteMailCustomer.firstname | titlecase}}  {{deleteMailCustomer.name | uppercase}}</span>
            <span class="col-12 text-center modal-text">{{deleteMailCustomer.mail }}</span>
        </div>
        <div class="btnConfirm row">
            <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="deleteDateMail()">{{'assistance.oui'|translate|titlecase}} </button>
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 " (click)="closeModal('confirmationDeleteMailModal')">{{'assistance.non'|translate|titlecase}} </button>
        </div>
    </div>
</div>

<!-- Confirmation DeleteAccount -->
<div id="confirmationDeleteAccountModal" class="modal">
    <div class="modal-content" id="confirmationDeleteAccountContent" *ngIf="confirmationDeleteAccount">
        <div class="col-12">
            <h3 class="modal-title text-center"> {{'manageaccount.supAccount'|translate}} </h3>
            <hr />
        </div>
        <div class="row mt-3 mb-3">
            <span class="col-12 text-center mb-4">{{'manageaccount.confirmDeleteAccount'|translate}}</span>
            <span class="col-12 text-center modal-text">{{deleteAccountCustomer.socialReason | uppercase}} - {{deleteAccountCustomer.firstname | titlecase}}  {{deleteAccountCustomer.name | uppercase}}</span>
            <span class="col-12 text-center modal-text">{{deleteAccountCustomer.mail }}</span>
        </div>
        <div class="btnConfirm row">
            <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="hiddeCustomer()">{{'assistance.oui'|translate|titlecase}} </button>
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 " (click)="closeModal('confirmationDeleteAccountModal')">{{'assistance.non'|translate|titlecase}} </button>
        </div>
    </div>
</div>

<!-- Redirection affectation materiel -->
<div id="redirectAffectationMaterielModal" class="modal">
    <div class="modal-content" id="redirectAffectationMaterielContent">
        <div class="col-12">
            <h3 class="modal-title text-center"> Souhaitez-vous affecter un materiel à votre client ? </h3>
            <hr />
        </div>
        <div class="btnConfirm row">
            <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="affectationMateriel()">{{'assistance.oui'|translate|titlecase}} </button>
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 " (click)="closeModal('redirectAffectationMaterielModal')">{{'assistance.non'|translate|titlecase}} </button>
        </div>
    </div>
</div>

<!-- Modal Editer -->
<div id="edit" class="modal">
    <div class="modal-content" id="modalEditContent" *ngIf="!validationModal && !confirmationDeleteMail && !confirmationDeleteAccount">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('edit');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> {{'manageaccount.customerInfo'|translate}} </h1>
            <span class="lastconnection-sub" *ngIf="lastConnectionDate && lastConnectionDate.length > 0">{{'manageaccount.lastConnection'|translate}} {{lastConnectionDate}}</span>
            <hr />
        </div>

        <div class="contain">
            <div class="alertmsg col-12 mb-4">
                <div class="msg">
                    <span *ngIf="emailExists" class="red">{{'manageaccount.emailExists'|translate}}</span>
                    <span *ngIf="(currentCustomer && currentCustomer.mailSended) || (otherCustomer && otherCustomer.mailSended)" class="red">{{'manageaccount.mailSended'|translate}}</span>
                </div>
                <div *ngIf="emailExists">
                    <button class="btn btn-secondary wide" (click)="showOtherCustomer('edit')" *ngIf="!showOtherEdit">{{'manageaccount.showInformation'|translate}}</button>
                    <button class="btn btn-secondary wide" (click)="hideOtherCustomer('edit')" *ngIf="showOtherEdit">{{'manageaccount.hideInformation'|translate}}</button>
                </div>
            </div>
            <div class="emailDiv form-group row justify-content-center " [formGroup]="editCustomerForm">
                <div class="col-12">
                    <mat-form-field class="col-12">
                        <mat-label>{{'renting.mailclient'|translate}}</mat-label>
                        <input matInput type="email" (input)="inputMail(editCustomerForm.value.email)" (change)="checkMail(editCustomerForm.value.email,'edit')" formControlName="email" required />
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field class="col-12">
                        <mat-label>{{'manageaccount.emergencyMail'|translate}}</mat-label>
                        <input matInput type="email" formControlName="emergencyMail" />
                    </mat-form-field>
                </div>
                <div *ngIf="showEditForm">
                    <div class="companyDiv justify-content-center col-12 customerForm">

                        <div>
                            <span class="col-12 bold">{{'register.companyInfo'|translate}}</span><br />
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                <input matInput formControlName="socialReason" required />
                            </mat-form-field>
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                <input matInput formControlName="address" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                <input matInput formControlName="postalCode" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                <input matInput formControlName="city" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                <mat-select formControlName="country" required (selectionChange)="getRegions(false,'edit', true); changeEditCustomerFormCountryFacturation();">
                                    <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="col-12 mt-2">
                                <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                                <input matInput formControlName="siren" required />
                            </mat-form-field>

                            <mat-form-field class="col-12 mt-2">
                                <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                                <input matInput formControlName="tva" required />
                            </mat-form-field>


                        </div>

                        <div>
                            <span class="col-12 bold">{{'register.userInfo'|translate}}</span><br />


                            <div class="col-12 col-sm-6">
                                <mat-checkbox formControlName="isAdminIVC">Admin IVC</mat-checkbox>
                            </div>


                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                                <input matInput formControlName="name" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                                <input matInput formControlName="firstName" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                                <input matInput type="tel" formControlName="mobile" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                                <input matInput type="tel" formControlName="phone" />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                                <mat-select formControlName="language">
                                    <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'contretypage.ctc'|translate}}</mat-label>
                                <mat-select formControlName="idCtc" (selectionChange)="ctcSelected('edit')">
                                    <mat-option *ngFor="let ctcFiltered of ctcsFiltered" value="{{ctcFiltered.idCtc}}">{{ctcFiltered.firstname}} {{ctcFiltered.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <br />
                            <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && editCustomerForm.value.country && editCustomerForm.value.country.toLowerCase() == 'france'">
                                <mat-label>{{'manageaccount.DR'|translate}}</mat-label>
                                <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('edit', 'dr')" required>
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && editCustomerForm.value.country && editCustomerForm.value.country.toLowerCase() == 'united kingdom'">
                                <mat-label>{{'manageaccount.country'|translate}}</mat-label>
                                <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('edit', 'dr')" required>
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>

                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenault && editCustomerForm.value.country && editCustomerForm.value.country.toLowerCase() == 'spain'">
                                <mat-label>{{'manageaccount.region'|translate}}</mat-label>
                                <mat-select formControlName="businessCode" (selectionChange)="loadCtcOfDrCustomer('edit', 'dr')" required>
                                    <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'register.customerNumber'|translate}}</mat-label>
                                <input matInput formControlName="customerNumber" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'register.customerCode'|translate}}</mat-label>
                                <input matInput formControlName="customerCode" required />
                            </mat-form-field>
                            <mat-form-field class="col-12 col-sm-6">
                                <mat-label>{{'manageaccount.compteTresor'|translate}}</mat-label>
                                <input matInput formControlName="compteTresor" required />
                            </mat-form-field>
                            <br />
                            <div class="scale" *ngIf="newCustomer">
                                <mat-radio-group formControlName="haveScale" class="col-12 col-sm-6">
                                    <span class="pr-1">{{'manageaccount.haveScale'|translate}}</span>
                                    <mat-radio-button class="ml-2" (change)="customerHaveScale(true)" (click)="customerHaveScale(true)" [value]="1">
                                        <span> {{'assistance.oui'|translate}} </span>
                                    </mat-radio-button>
                                    <mat-radio-button class="ml-2" (change)="customerHaveScale(false)" (click)="customerHaveScale(false)" [value]="2">
                                        <span> {{'assistance.non'|translate}}</span>
                                    </mat-radio-button>
                                </mat-radio-group>
                                <mat-form-field *ngIf="haveScale" class="paintBrand">
                                    <mat-label>{{'register.brand'|translate}}</mat-label>
                                    <mat-select formControlName="paintBrand">
                                        <mat-option *ngFor="let paintBrand of listOfBrands" [value]="paintBrand">{{paintBrand}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="action col-12">
                        <button *ngIf="!newCustomer && !haveChangeMailPrincipal" class="btn btn-secondary col-5 col-lg-5 col-md-5 col-sm-5 actionButton" (click)="saveCustomer('edit')">{{'manageaccount.save'|translate}}</button>
                        <button class="btn btn-secondary col-5 col-lg-5 col-md-5 col-sm-5 actionButton" (click)="saveAndSendCustomerEdit('edit')" [disabled]="emailExists">{{'manageaccount.sendID'|translate}}</button>
                    </div>
                    <div class="col-12 text-center mt-3"> <span *ngIf="msgConfirmation">{{'manageaccount.msgRegister'|translate}}</span></div>
                </div>
            </div>

            <div *ngIf="showOtherEdit">
                <form [formGroup]="otherCustomerForm" class="customerForm otherCustomerForm">
                    <div class="companyDiv">
                        <span class="col-12 bold">{{'register.companyInfo'|translate}}{{'manageaccount.existingf'|translate}}</span><br />
                        <mat-form-field class="col-12">
                            <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                            <input matInput formControlName="socialReason" required [readonly]="otherCustomer.socialReason != null && otherCustomer.socialReason != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12">
                            <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                            <input matInput formControlName="address" required [readonly]="otherCustomer.address != null && otherCustomer.address != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                            <input matInput formControlName="postalCode" required [readonly]="otherCustomer.postalCode != null && otherCustomer.postalCode != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                            <input matInput formControlName="city" required [readonly]="otherCustomer.city != null && otherCustomer.city != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                            <mat-select formControlName="country" required (selectionChange)="getRegions(true,'edit', true); changeOtherCustomerFormCountryFacturation();">
                                <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                            <input matInput formControlName="siren" required />
                        </mat-form-field>

                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                            <input matInput formControlName="tva" required />
                            <mat-error>{{'scaleform.tvaerror'|translate}}</mat-error>
                        </mat-form-field>

                    </div>

                    <div class="customerDiv">
                        <span class="col-12 bold">{{'register.userInfo'|translate}}{{'manageaccount.existingm'|translate}}</span><br />

                        <div class="col-12 col-sm-6">
                            <mat-checkbox formControlName="isAdminIVC" [readonly]="true">Admin IVC</mat-checkbox>
                        </div>

                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                            <input matInput formControlName="name" required [readonly]="otherCustomer.name != null && otherCustomer.name != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                            <input matInput formControlName="firstName" required [readonly]="otherCustomer.firstname != null && otherCustomer.firstname != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                            <input matInput type="tel" formControlName="mobile" required [readonly]="otherCustomer.mobilePhone != null && otherCustomer.mobilePhone != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                            <input matInput type="tel" formControlName="phone" [readonly]="otherCustomer.phone != null && otherCustomer.phone != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                            <mat-select formControlName="language" required>
                                <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <br />
                        <mat-form-field class="col-12 col-sm-6" *ngIf="mprRenaultOther">
                            <mat-label>{{'register.businessCode'|translate}}</mat-label>
                            <mat-select formControlName="businessCode">
                                <mat-option *ngFor="let region of regions" value="{{region}}"> {{region}} </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'register.customerNumber'|translate}}</mat-label>
                            <input matInput formControlName="customerNumber" required [readonly]="otherCustomer.mrpAccount != null && otherCustomer.mrpAccount != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'register.customerCode'|translate}}</mat-label>
                            <input matInput formControlName="customerCode" required [readonly]="otherCustomer.customerCode != null && otherCustomer.customerCode != ''" />
                        </mat-form-field>
                        <mat-form-field class="col-12 col-sm-6">
                            <mat-label>{{'manageaccount.compteTresor'|translate}}</mat-label>
                            <input matInput formControlName="compteTresor" required [readonly]="otherCustomer.compteTresor != null && otherCustomer.compteTresor != ''" />
                        </mat-form-field>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>


<!-- Modal Afficher Plus -->
<div id="seeMore" class="modal">
    <div class="modal-content" id="modalEditContent" *ngIf="!validationModal && !confirmationDeleteMail && !confirmationDeleteAccount && seeMoreCustomer">
        <table>
            <tbody>
                <tr *ngIf="displayedColumns.includes('companySocialReason')">
                    <th>{{'scaleform.raisonsociale'|translate}}</th>
                    <td>{{seeMoreCustomer.socialReason}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('address')">
                    <th>{{'scaleform.adresse'|translate}}</th>
                    <td>
                        <div class="address">
                            <span>{{seeMoreCustomer.address}}</span>
                            <span>{{seeMoreCustomer.postalCode}} {{seeMoreCustomer.city}}</span>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="displayedColumns.includes('firstName')">
                    <th>{{'scaleform.prenom'|translate}}</th>
                    <td>{{seeMoreCustomer.firstname}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('name')">
                    <th>{{'scaleform.nom'|translate}}</th>
                    <td>{{seeMoreCustomer.name}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('mail')">
                    <th>{{'scaleform.mail'|translate}}</th>
                    <td style="word-break: break-all">{{seeMoreCustomer.mail}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('sended')">
                    <th>{{'manageaccount.mailsended'|translate}}</th>
                    <td><span *ngIf="seeMoreCustomer.mailSended">{{seeMoreCustomer.dateMailSent}}</span></td>
                </tr>
                <tr *ngIf="displayedColumns.includes('histo')">
                    <th>{{'manageaccount.connection'|translate}}</th>
                    <td>{{seeMoreCustomer.nbConnection}}</td>
                </tr>
                <tr *ngIf="displayedColumns.includes('action')">
                    <th>
                        <div class="d-inline-flex flex-row justify-content-center align-items-center">
                            <span>{{'manageaccount.action'|translate}}</span>
                            <div class="spanAction"><i aria-hidden="true" class="fal fa-2x fa-info-circle primaryInfo" title="{{'manageaccount.infoBoutonAction'|translate}}"></i></div>
                        </div>
                    </th>
                    <td>
                        <table class="actionTable" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="actionmail" *ngIf="seeMoreCustomer.mailSended" (click)="closeModal('seeMore'); openDeleteMailModal(seeMoreCustomer)" matTooltip="{{'manageaccount.deleteDateMail'|translate}}">
                                            <i aria-hidden="true" class="fal fa-recycle fa-2x primaryGrey actionIcon"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="actionhidde" *ngIf="seeMoreCustomer.ctcCreated" (click)="closeModal('seeMore'); openDeleteAccountModal(seeMoreCustomer)" matTooltip="{{'manageaccount.hidde'|translate}}">
                                            <i aria-hidden="true" class="fal fa-trash-alt fa-2x primaryGrey actionIcon"></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="actionedit" (click)="closeModal('seeMore'); editCustomer(seeMoreCustomer)" matTooltip="{{'manageaccount.edit'|translate}}">
                                            <i aria-hidden="true" class="fal fa-edit fa-2x primaryGrey actionIcon primaryGrey-{{seeMoreCustomer.haveCtcAndDR}}"></i>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btnConfirm">
            <button class="btn btn-danger" (click)="closeModal('seeMore')">{{'activlist.fermer'|translate}} </button>
        </div>
    </div>
</div>

<!-- Modal preprod -->
<div id="infoPreprodModal" class="modal">
    <div class="modal-content" id="infoPreprodContent" *ngIf="infoPreprod">

        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModalPreprod('infoPreprodModal');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> Informations preprod </h1>
        </div>

        <div class="col-12">
            <h3 class="modal-title text-center"> Attention, vous êtes sur un environnement de test. Aucun mail n'est envoyer pour initialiser / modifier le mot de passe du client.</h3>
        </div>
        <div class="btnConfirm row">
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 " (click)="closeModalPreprod('infoPreprodModal')">{{'activlist.fermer'|translate|titlecase}} </button>
        </div>
    </div>
</div>
